import React from 'react'
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaInstagram, FaLinkedinIn } from "react-icons/fa";

function Footer() {
    return (
        <>

            <footer className="footer-section text-white" style={{ backgroundColor: "rgba(9, 26, 58, 1)" }}>
                <div className="container py-5">
                    <div className="row text-start">

                        {/* Company Info */}
                        <div className="col-md-4 mb-4">
                            <h5 className="fw-bold mb-3 text-white">TNWC</h5>
                            <p className="small">
                                TNWC provides reliable and secure warehousing and logistics
                                solutions across Tamil Nadu, ensuring safe storage and timely
                                distribution.
                            </p>
                        </div>

                        {/* Quick Links */}
                        <div className="col-md-2 mb-4">
                            <h6 className="fw-bold mb-3 text-white">Quick Links</h6>
                            <ul className="list-unstyled footer-links">
                                <li><a href="/" className='text-white'>Home</a></li>
                                <li><a href="/" className='text-white'>Services</a></li>
                                <li><a href="/" className='text-white'>Locations</a></li>
                                <li><a href="/" className='text-white'>Contact</a></li>
                            </ul>
                        </div>

                        {/* Services */}
                        <div className="col-md-3 mb-4">
                            <h6 className="fw-bold mb-3 text-white">Our Services</h6>
                            <ul className="list-unstyled footer-links">
                                <li>Warehousing</li>
                                <li>Cold Storage</li>
                                <li>Inventory Management</li>
                                <li>Transportation</li>
                            </ul>
                        </div>

                        {/* Contact Info */}
                        <div className="col-md-3 mb-4">
                            <h6 className="fw-bold mb-3 text-white">Contact</h6>
                            <p className="small mb-1">
                                <FaMapMarkerAlt /> Tamil Nadu, India
                            </p>
                            <p className="small mb-1">
                                <FaPhoneAlt /> +91 95**470870
                            </p>
                            <p className="small">
                                <FaEnvelope /> info@tnwc.com
                            </p>

                            {/* Social Icons */}
                            <div className="footer-social d-flex justify-content-start gap-3 mt-3">
                                <a href="#"><FaFacebookF /></a>
                                <a href="#"><FaInstagram /></a>
                                <a href="#"><FaLinkedinIn /></a>
                            </div>

                        </div>

                    </div>
                </div>

                <div className=" text-danger ">
                    <hr className="w-75 opacity-90 mx-auto" style={{ color: "white" }} />
                </div>

                {/* Bottom Bar */}
                <div className="footer-bottom text-center py-3">
                    © 2025 TNWC. All rights reserved.
                </div>
            </footer>
        </>

    );
}

export default Footer